function init(container: HTMLElement | Document = document) {
    const url = window.location.origin + window.location.pathname;
    window.history.replaceState(null, '', url);
}

const _module = { init };

export default _module;
